import _regenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import MaterialInput from '@/components/MaterialInput/index.vue';
import Sticky from '@/components/Sticky/index.vue';
import Tinymce from '@/components/Tinymce/index.vue';
import { createMissionInfoReading, getMissionInfoReading, updateMissionInfoReading } from '@/api/missionInfoReading';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "reading", void 0);
    _defineProperty(_this, "title", void 0);
    _defineProperty(_this, "visible", void 0);
    _defineProperty(_this, "action", void 0);
    _defineProperty(_this, "isEdit", void 0);
    _defineProperty(_this, "validateRequire", function (rule, value, callback) {
      if (value === '') {
        _this.$message({
          message: rule.field + ' is required',
          type: 'error'
        });
        callback(new Error(rule.field + ' is required'));
      } else {
        callback();
      }
    });
    _defineProperty(_this, "postForm", Object.assign({}, _this.reading));
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "rules", {
      title: [{
        validator: _this.validateRequire
      }],
      content: [{
        validator: _this.validateRequire
      }]
    });
    _defineProperty(_this, "tinymceActive", true);
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "handleClose",
    value: function handleClose() {
      this.tinymceActive = false;
      this.$emit('update:visible', false);
    }
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      var form = this.$refs['dataForm'];
      if (form) form.resetFields();
      this.tinymceActive = true;
      this.postForm = Object.assign({}, this.reading);
      this.fetchData();
    }
  }, {
    key: "lang",
    get: function get() {
      return AppModule.language;
    }
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var reading;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.reading.id) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return getMissionInfoReading(this.reading.missionInfoId, this.reading.id);
            case 1:
              reading = _context.v;
              this.postForm = reading;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }, {
    key: "submitForm",
    value: function submitForm() {
      var $this = this;
      this.$refs.postForm.validate(function (valid) {
        if (valid) {
          $this.loading = true;
          var promise = null;
          if ($this.postForm.id) {
            promise = updateMissionInfoReading($this.postForm);
          } else {
            promise = createMissionInfoReading($this.postForm);
          }
          promise.then(function (res) {
            $this.$notify({
              title: 'Success',
              message: 'Saved successfully',
              type: 'success',
              duration: 2000
            });
            $this.postForm = res;
            $this.loading = false;
          }).catch(function (err) {
            $this.$notify({
              title: 'Error',
              message: 'Failed to Saved',
              type: 'error',
              duration: 2000
            });
            console.error(err);
            $this.loading = false;
          });
        } else {
          console.error('Submit Error!');
          return false;
        }
      });
    }
  }]);
}(Vue);
__decorate([Prop({
  required: false
})], default_1.prototype, "reading", void 0);
__decorate([Prop({
  required: false
})], default_1.prototype, "title", void 0);
__decorate([Prop({
  required: false
})], default_1.prototype, "visible", void 0);
__decorate([Prop({
  required: false
})], default_1.prototype, "action", void 0);
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
default_1 = __decorate([Component({
  name: 'WriteReading',
  components: {
    MaterialInput: MaterialInput,
    Sticky: Sticky,
    Tinymce: Tinymce
  }
})], default_1);
export default default_1;